module.exports = __webpack_public_path__ + "media/assets/faria_products/MIDDLE-a1a015c6c7e1fc39878fb6f7d823fc925ad3a2a046f053f8e60df08ff4026cbd.png";